import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";

const Table = ({  apidata }) => {
    const [items, setItems] = useState([]);
    const[selectedCompany,setSelectedCompanyAccounts] = useState([])
    useEffect(() => {
        if (apidata) {
            setItems(apidata.links || []);
        }
    }, [apidata]);

    const links = items.map((item) => ({
        link_doctype: item.link_doctype,
        link_name: item.link_name
    }));

    const createNewRow = () => ({
        link_doctype: "",
        link_name: ""
    });

    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState(links.length > 0 ? links : [createNewRow()]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        setRows([...rows, createNewRow()]);
        const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    useEffect(() => {
        const filtered = rows
            .filter(row => row.link_doctype && row.link_name)
            .map(row => ({
                link_doctype: row.link_doctype,
                link_name: row.link_name
            }));
        setSelectedCompanyAccounts(filtered);
    }, [rows]);
    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>           
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '350px' }}>Link Document Type</th>
                        <th style={{ width: '350px' }}>Link Name</th>
                        <th style={{ width: '250px', textAlign: 'center' }}>
                            <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {links.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        return (
                            <tr key={globalIndex}>           
                              <td style={{ textAlign: "center" }}><span style={{ fontSize: '0.8rem' }}
                                >{globalIndex + 1}</span></td>
                                <td className="p-0">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        style={{fontSize:'0.8rem',textAlign:'center'}}
                                        value={row.link_doctype}
                                        onChange={(e) => updateRow(globalIndex, "link_doctype", e.target.value)}
                                    />
                                </td>
                                <td className="p-0">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        style={{fontSize:'0.8rem',textAlign:'center'}}
                                        value={row.link_name}
                                        onChange={(e) => updateRow(globalIndex, "link_name", e.target.value)}
                                    />
                                </td>
                                <td className="p-0">
                                    <GetIcon iconName="MdOutlineEdit" size={13}style={{marginTop:'5px'}} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="d-flex pb-2 justify-content-between align-items-center">
                <div className="d-flex" style={{ gap: '4px' }}>                        
                </div>
                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;